import React from "react";
import { KoModal } from "packages";
import Comments from "pages/workspace/process/development/task/comments";
import styles from "./comentsModal.module.scss";

const CommnetsModal = ({isCommnetsModalOpen, workspaceId, classNameMain, ticketId, setCreateComment, setCommnetsModal, isCommentsModal}) => {
  

  return (
    <KoModal
      title={`${ticketId} - Comments`}
      open={isCommnetsModalOpen}
      width={'70%'}
      centered
      onClose={setCommnetsModal}
    >
      <Comments className={`${styles.wrapperOverflow} }`} classNameMain={classNameMain}
        workspaceId={workspaceId}
        ticketId={ticketId}
        setCreateComment={setCreateComment}
        isOpenCommentsModal={isCommentsModal}/>
    </KoModal>
  );
};

export default CommnetsModal;
